module.exports = __webpack_public_path__ + "img/userLogo24.54a3b3a6.jpg";